// Datenquelle: astrowoche.de „Chinesisches Sternzeichen berechnen: So ist es ganz einfach“ (Stand 17.02.2026)
// Tupel je Zeichenwechsel: [von (YYYY-MM-DD), bis (YYYY-MM-DD), Tier, Element]
// Im Artikel fehlt bei drei Zeilen das „bis“ bzw. steht „198“ statt „1983“; die Zeiträume sind anhand der lückenlosen Folge korrigiert.
export type ChineseAnimal = 'Ratte' | 'Büffel' | 'Tiger' | 'Hase' | 'Drache' | 'Schlange' | 'Pferd' | 'Ziege' | 'Affe' | 'Hahn' | 'Hund' | 'Schwein'
export type ChineseElement = 'Holz' | 'Feuer' | 'Erde' | 'Metall' | 'Wasser'
export type ChineseSignRange = [string, string, ChineseAnimal, ChineseElement]

export const chineseSignTable: ChineseSignRange[] = [
  ['1950-02-17', '1951-02-05', 'Tiger', 'Metall'],
  ['1951-02-06', '1952-01-26', 'Hase', 'Metall'],
  ['1952-01-27', '1953-02-13', 'Drache', 'Wasser'],
  ['1953-02-14', '1954-02-02', 'Schlange', 'Wasser'],
  ['1954-02-03', '1955-01-23', 'Pferd', 'Holz'],
  ['1955-01-24', '1956-02-11', 'Ziege', 'Holz'],
  ['1956-02-12', '1957-01-30', 'Affe', 'Feuer'],
  ['1957-01-31', '1958-02-17', 'Hahn', 'Feuer'],
  ['1958-02-18', '1959-02-07', 'Hund', 'Erde'],
  ['1959-02-08', '1960-01-27', 'Schwein', 'Erde'],
  ['1960-01-28', '1961-02-14', 'Ratte', 'Metall'],
  ['1961-02-15', '1962-02-04', 'Büffel', 'Metall'],
  ['1962-02-05', '1963-01-24', 'Tiger', 'Wasser'],
  ['1963-01-25', '1964-02-12', 'Hase', 'Wasser'],
  ['1964-02-13', '1965-02-01', 'Drache', 'Holz'],
  ['1965-02-02', '1966-01-20', 'Schlange', 'Holz'],
  ['1966-01-21', '1967-02-08', 'Pferd', 'Feuer'],
  ['1967-02-09', '1968-01-29', 'Ziege', 'Feuer'],
  ['1968-01-30', '1969-02-16', 'Affe', 'Erde'],
  ['1969-02-17', '1970-02-05', 'Hahn', 'Erde'],
  ['1970-02-06', '1971-01-26', 'Hund', 'Metall'],
  ['1971-01-27', '1972-02-14', 'Schwein', 'Metall'],
  ['1972-02-15', '1973-02-02', 'Ratte', 'Wasser'],
  ['1973-02-03', '1974-01-22', 'Büffel', 'Wasser'],
  ['1974-01-23', '1975-02-10', 'Tiger', 'Holz'],
  ['1975-02-11', '1976-01-30', 'Hase', 'Holz'],
  ['1976-01-31', '1977-02-17', 'Drache', 'Feuer'],
  ['1977-02-18', '1978-02-06', 'Schlange', 'Feuer'],
  ['1978-02-07', '1979-01-27', 'Pferd', 'Erde'],
  ['1979-01-28', '1980-02-15', 'Ziege', 'Erde'],
  ['1980-02-16', '1981-02-04', 'Affe', 'Metall'],
  ['1981-02-05', '1982-01-24', 'Hahn', 'Metall'],
  ['1982-01-25', '1983-02-12', 'Hund', 'Wasser'],
  ['1983-02-13', '1984-02-01', 'Schwein', 'Wasser'],
  ['1984-02-02', '1985-02-19', 'Ratte', 'Holz'],
  ['1985-02-20', '1986-02-08', 'Büffel', 'Holz'],
  ['1986-02-09', '1987-01-28', 'Tiger', 'Feuer'],
  ['1987-01-29', '1988-02-16', 'Hase', 'Feuer'],
  ['1988-02-17', '1989-02-05', 'Drache', 'Erde'],
  ['1989-02-06', '1990-01-26', 'Schlange', 'Erde'],
  ['1990-01-27', '1991-02-14', 'Pferd', 'Metall'],
  ['1991-02-15', '1992-02-03', 'Ziege', 'Metall'],
  ['1992-02-04', '1993-01-22', 'Affe', 'Wasser'],
  ['1993-01-23', '1994-02-09', 'Hahn', 'Wasser'],
  ['1994-02-10', '1995-01-30', 'Hund', 'Holz'],
  ['1995-01-31', '1996-02-18', 'Schwein', 'Holz'],
  ['1996-02-19', '1997-02-06', 'Ratte', 'Feuer'],
  ['1997-02-07', '1998-01-27', 'Büffel', 'Feuer'],
  ['1998-01-28', '1999-02-15', 'Tiger', 'Erde'],
  ['1999-02-16', '2000-02-04', 'Hase', 'Erde'],
  ['2000-02-05', '2001-01-23', 'Drache', 'Metall'],
  ['2001-01-24', '2002-02-11', 'Schlange', 'Metall'],
  ['2002-02-12', '2003-01-31', 'Pferd', 'Wasser'],
  ['2003-02-01', '2004-01-21', 'Ziege', 'Wasser'],
  ['2004-01-22', '2005-02-08', 'Affe', 'Holz'],
  ['2005-02-09', '2006-01-28', 'Hahn', 'Holz'],
  ['2006-01-29', '2007-02-17', 'Hund', 'Feuer'],
  ['2007-02-18', '2008-02-06', 'Schwein', 'Feuer'],
  ['2008-02-07', '2009-01-25', 'Ratte', 'Erde'],
  ['2009-01-26', '2010-02-13', 'Büffel', 'Erde'],
  ['2010-02-14', '2011-02-02', 'Tiger', 'Metall'],
  ['2011-02-03', '2012-01-22', 'Hase', 'Metall'],
  ['2012-01-23', '2013-02-09', 'Drache', 'Wasser'],
  ['2013-02-10', '2014-01-30', 'Schlange', 'Wasser'],
  ['2014-01-31', '2015-02-18', 'Pferd', 'Holz'],
  ['2015-02-19', '2016-02-07', 'Ziege', 'Holz'],
  ['2016-02-08', '2017-01-27', 'Affe', 'Feuer'],
  ['2017-01-28', '2018-02-15', 'Hahn', 'Feuer'],
  ['2018-02-16', '2019-02-04', 'Hund', 'Erde'],
  ['2019-02-05', '2020-01-24', 'Schwein', 'Erde'],
  ['2020-01-25', '2021-02-11', 'Ratte', 'Metall'],
  ['2021-02-12', '2022-01-31', 'Büffel', 'Metall'],
  ['2022-02-01', '2023-01-21', 'Tiger', 'Wasser'],
  ['2023-01-22', '2024-02-09', 'Hase', 'Wasser'],
  ['2024-02-10', '2025-01-28', 'Drache', 'Holz'],
  ['2025-01-29', '2026-02-16', 'Schlange', 'Holz'],
  ['2026-02-17', '2027-02-05', 'Pferd', 'Feuer'],
  ['2027-02-06', '2028-01-25', 'Ziege', 'Feuer'],
  ['2028-01-26', '2029-02-12', 'Affe', 'Erde'],
  ['2029-02-13', '2030-02-01', 'Hahn', 'Erde']
]

// Artikel vor dem Tier (für den Ergebnissatz) und Link zur Sternzeichenseite auf astrowoche.wunderweib.de
export const chineseSignPages: Record<ChineseAnimal, { label: string, url: string }> = {
  Ratte: { label: 'die Ratte', url: '/das-chinesische-sternzeichen-die-ratte-1469.html' },
  Büffel: { label: 'der Büffel', url: '/das-chinesisches-sternzeichen-der-bueffel-1470.html' },
  Tiger: { label: 'der Tiger', url: '/das-chinesische-sternzeichen-der-tiger-1471.html' },
  Hase: { label: 'der Hase', url: '/das-chinesische-sternzeichen-der-hase-1472.html' },
  Drache: { label: 'der Drache', url: '/das-chinesische-sternzeichen-der-drache-1473.html' },
  Schlange: { label: 'die Schlange', url: '/das-chinesische-sternzeichen-die-schlange-1474.html' },
  Pferd: { label: 'das Pferd', url: '/das-chinesische-sternzeichen-das-pferd-1475.html' },
  Ziege: { label: 'die Ziege', url: '/das-chinesische-sternzeichen-die-ziege-1476.html' },
  Affe: { label: 'der Affe', url: '/das-chinesische-sternzeichen-der-affe-1477.html' },
  Hahn: { label: 'der Hahn', url: '/das-chinesische-sternzeichen-der-hahn-1478.html' },
  Hund: { label: 'der Hund', url: '/das-chinesische-sternzeichen-der-hund-1479.html' },
  Schwein: { label: 'das Schwein', url: '/das-chinesische-sternzeichen-das-schwein-1480.html' }
}
